import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { Disposable, toDisposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IConfigurationService } from 'vscode/vscode/vs/platform/configuration/common/configuration.service';
import { LinkedList } from 'vscode/vscode/vs/base/common/linkedList';

let WorkingCopyFileOperationParticipant = class WorkingCopyFileOperationParticipant extends Disposable {
    constructor(logService, configurationService) {
        super();
        this.logService = logService;
        this.configurationService = configurationService;
        this.participants = ( new LinkedList());
    }
    addFileOperationParticipant(participant) {
        const remove = this.participants.push(participant);
        return toDisposable(() => remove());
    }
    async participate(files, operation, undoInfo, token) {
        const timeout = this.configurationService.getValue('files.participants.timeout');
        if (typeof timeout !== 'number' || timeout <= 0) {
            return;
        }
        for (const participant of this.participants) {
            try {
                await participant.participate(files, operation, undoInfo, timeout, token);
            }
            catch (err) {
                this.logService.warn(err);
            }
        }
    }
    dispose() {
        this.participants.clear();
        super.dispose();
    }
};
WorkingCopyFileOperationParticipant = ( __decorate([
    ( __param(0, ILogService)),
    ( __param(1, IConfigurationService))
], WorkingCopyFileOperationParticipant));

export { WorkingCopyFileOperationParticipant };
